export const mapsApiKey = 
    process.env.NODE_ENV === 'development' ? 'AIzaSyAkFJnVCG2aSok3Y3USuEs7DllYEjLKdvI' : 'AIzaSyAbAEiXGpqxoxoMamOoXez93oVxMKjl37A';
export const mapsApiEndpoint = 'https://maps.googleapis.com/maps/api';